module.exports = __webpack_public_path__ + "static/media/img05.231b6c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/02/assets/img05.jpg
// module id = 358
// module chunks = 0